import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';


import CustomerWebPortalDashboard from './Dashboard';
import CustomerOrders from './CustomerOrders';
import CustomerOrder  from './CustomerOrder';

import CustomerMenu from './MenuSettings';
import CustomerMenuListItem from './Item';
import CustomerMenuList from './List';
import CustomerGeneral from './GeneralSettings';


class CustomerWebPortal extends Component {

    render () {
        return (
            <Switch>
                <Route path="/dashboard" exact component={ CustomerWebPortalDashboard } />
                <Route path="/customer-orders" exact component={ CustomerOrders } />
                <Route path="/customer-orders/:id" exact component={ CustomerOrder } />
                <Route path="/menu" exact component={ CustomerMenu } />
                {/*<Route path="/menu/:menuId/list" exact component={ CustomerMenuList } />*/}
                <Route path="/menu/:menuId/item" exact component={ CustomerMenuListItem } />
                <Route path="/general-settings" component={ CustomerGeneral } />
                <Redirect to="/dashboard" />
            </Switch>
        )
    }
}

export default CustomerWebPortal;



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/index.js